<div class="process">
  <sb-header
    [steps]="availableSteps"
    [title]="(activeStep && activeStep.label || '') | translate"
    [activeStep]="activeStep"
    [showStepActiveLabel]="true"
    [showStepsLabels]="false"
    [offer]="offer"
    [offerAlternative]="offerAlternative"
    [offerExtras]="offerExtras"
    [hasDoublePO]="hasDoublePO"
    [promos]="promos"
    [cart]="cart"
    [simType]="simType"
    [showCart]="shouldShowCart"
    [availableActivationMethods]="availableActivationMethods"
    [availableOperators]="availableOperators"
    (cartIsOpen)="onCartToggle($event)"
  ></sb-header>

  <div class="process__container">
    <div class="process__content"> <!-- [@routeAnimations]="getRouteAnimation(outlet)" > -->
      <router-outlet #outlet="outlet"></router-outlet>
    </div>
    <div class="process__footer" #navButtons>
    </div>
  </div>
</div>
<!--<sb-debug-info></sb-debug-info>-->
<!--<sb-storage-form></sb-storage-form>-->
